import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   messageId: null,
   chatId: null,
   chatType: null,
   isPostViewOpen: false,
};

const mediaPreviewSlice = createSlice({
   name: 'mediaPreview',
   initialState,
   reducers: {
      setPostPreview: (state, action) => {
         const { messageId, chatId, chatType } = action.payload;
         state.messageId = messageId;
         state.chatId = chatId;
         state.chatType = chatType;
         state.isPostViewOpen = true;
      },
      clearPostPreview: state => {
         state.messageId = null;
         state.chatId = null;
         state.chatType = null;
         state.isPostViewOpen = false;
      },
   },
});

export const { setPostPreview, clearPostPreview } = mediaPreviewSlice.actions;

export const { reducer: mediaPreviewReducer } = mediaPreviewSlice;
